var map = {
	"./Modules/Admin/Dealers/dealer.module": "./src/app/Modules/Admin/Dealers/dealer.module.ts",
	"./Modules/Admin/Support-Engineer/supporteng.module": "./src/app/Modules/Admin/Support-Engineer/supporteng.module.ts",
	"./Modules/Admin/Support-Leader/supportleader.module": "./src/app/Modules/Admin/Support-Leader/supportleader.module.ts",
	"./Modules/Admin/admin.module": "./src/app/Modules/Admin/admin.module.ts",
	"./Modules/Provider/Project Leader/projectleader.module": "./src/app/Modules/Provider/Project Leader/projectleader.module.ts",
	"./Modules/Provider/Project-Manager/projectmanager.module": "./src/app/Modules/Provider/Project-Manager/projectmanager.module.ts",
	"./Modules/Provider/developer.module": "./src/app/Modules/Provider/developer.module.ts",
	"./Modules/Provider/tester.module": "./src/app/Modules/Provider/tester.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;